import { TextButton, typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const StyledTextButton = styled(TextButton)`
  ${typo.caption600};
  overflow: visible;
`;
